import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/ping';

export default {
  ping(hostName: string, nodeName: string, isHongKong: boolean, callback: (res: string) => void) {
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .get($url)
      .then((response: AxiosResponse<string>) => {
        callback(response.data);
      })
      .catch(() => {
        callback('error');
      });
  },
};
